import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSync12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowSync12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.923 2.62c-1.88-.504-3.717.527-4.257 2.382H4.49a.5.5 0 1 1 0 1H1v-3.5a.5.5 0 1 1 1 0v1.46c.932-1.893 3.048-2.88 5.182-2.308.783.21 1.462.603 2 1.124a.5.5 0 0 1-.696.718 3.55 3.55 0 0 0-1.563-.876M5.08 9.382C6.96 9.886 8.794 8.855 9.334 7H7.511a.5.5 0 1 1 0-1H11v3.5a.5.5 0 0 1-1 0V8.04c-.932 1.893-3.046 2.88-5.18 2.308a4.55 4.55 0 0 1-1.998-1.124.5.5 0 1 1 .696-.718c.415.403.943.71 1.562.876"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowSync12);
